<template>
  <v-tooltip
    v-bind="{...defaults, ...$attrs}"
    class="ol-tooltip"
    v-on="$listeners"
  >
    <template
      v-for="(_, slot) of $scopedSlots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </v-tooltip>
</template>

<script>

export default {
  name: 'OlTooltip',
  inheritAttrs: false,
  beforeCreate() {
    this.defaults = {
      'internal-activator': false,
      bottom: true,
      'max-width': '300px'
    }
  }
}
</script>

<style lang="scss">

/* TODO don't need whole component for this... */

.v-tooltip__content {
  color: var(--v-cornflowerblue-base);
  background: white;
  border-radius: 4px;

  &:before {
    background-color: currentColor;
    border-radius: inherit;
    bottom: 0;
    content: '';
    left: 0;
    opacity: 0.12;
    position: absolute;
    pointer-events: none;
    right: 0;
    top: 0;
  }

}

</style>
